import Vue from "vue";
import store from "@/state/store";
import i18n from "@/plugins/i18n";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

const dateFilter = value => {
  return formatDate(value);
};
const dateFilterWithHour = value => {
  return formatDate(value, true);
};

function formatDate(inputDate, showHour = false) {
  if (!inputDate) return "";

  inputDate = inputDate.replace(/-/g, "/");
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  let formattedDate;
  if (showHour) {
    formattedDate =
      months[month] + ", " + day + " " + year + " " + hour + ":" + minutes;
  } else {
    formattedDate = months[month] + ", " + day + " " + year;
  }
  return formattedDate;
}

Vue.filter("currencyFormatted", function(value, includeSymbol) {
  if (!value && value !== 0) return "";
  const newAmount = parseFloat(value).toFixed(2);

  // Get current language from i18n instance
  const locale = i18n.locale || "en";

  // Format number based on locale
  let formattedAmount;
  if (locale === "es") {
    // Spanish format: 1.000,00
    const [intPart, decPart] = newAmount.split(".");
    formattedAmount =
      intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + decPart;
  } else {
    // English format: 1,000.00
    formattedAmount = newAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  if (!includeSymbol) return formattedAmount;

  // Get currency from store
  const adminSettings = store.getters["general/getAdminSettings"];
  const currency = adminSettings?.get("currency")?.value || "$";

  return currency + formattedAmount;
});

Vue.filter("date1", dateFilter);

Vue.filter("date2", dateFilterWithHour);
